import { connect } from 'react-redux';
import { push } from "react-router-redux";
import { getUser } from '../redux/actions/AccountSetting';
import { getUser as getUserSelector } from '../redux/selectors/accountSettingSelector';
import * as actions from '../redux/actions/LetterAutoGenerate';
import LetterAutoGenerate from '../components/LetterAutoGenerate/LetterAutoGenerate';

const mapStateToProps = (state) => {
  return {
    pathname: state.router.location.pathname,
    user: getUserSelector(state),
    isGenerating: state.letterAutoGenerate.isGenerating,
    generatedContents: state.letterAutoGenerate.generatedContents,
    successMessage: state.letterAutoGenerate.successMessage,
    errorMessage: state.letterAutoGenerate.errorMessage,
    shortMessage: state.letterAutoGenerate.shortMessage,
  };
};

const mapDispatchToProps = dispatch => ({
  goTo(url, state) {
    dispatch(push(url, state));
  },

  getUserInfo() {
    dispatch(getUser());
  },

  postGenerate(data) {
    dispatch(actions.postGenerate(data));
  }
});

export default connect(mapStateToProps, mapDispatchToProps)(LetterAutoGenerate);



// WEBPACK FOOTER //
// ./src/containers/LetterAutoGenerate.js